import { AxiosInstance } from 'axios';
import { BaseRepository } from './BaseRepository';

export class UserRepository extends BaseRepository {
  constructor(client: AxiosInstance) {
    super(client, 'users');
  }

  // Override get to force entityId: 'me' default behavior if needed, 
  // or adds specific 'me' method.
  public async getMe() {
    return this.get({ entityId: 'me' });
  }
}

